import { z } from 'zod';
import type { TFunction } from 'i18next';
import { getDateTimestamp } from '@/shared/utils/dateUtils';

/** Manual time-entry form: both bounds required, end must be after start. */
export const createManualEntrySchema = (t: TFunction) =>
  z
    .object({
      startTime: z.string().min(1, t('timeTracking:errors.startTimeRequired')),
      endTime: z.string().min(1, t('timeTracking:errors.endTimeRequired')),
      description: z.string().trim().max(500).optional(),
      isBillable: z.boolean(),
    })
    .refine(
      (v) => {
        const start = getDateTimestamp(v.startTime);
        const end = getDateTimestamp(v.endTime);
        return start !== null && end !== null && end > start;
      },
      { path: ['endTime'], message: t('timeTracking:entryForm.endBeforeStart') },
    );

export type ManualEntryFormValues = z.infer<ReturnType<typeof createManualEntrySchema>>;
